export default "__VITE_ASSET__BmiLFJbv__"